import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import React, { useEffect } from 'react';
import i18n from 'i18next';
import { Modal, Button, Form, message } from 'antd';
import { apis } from '../api/index.js';

const Delete = props => {
  useEffect(() => {
    if (props.visible) props.form.resetFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible]);

  const handleOk = e => {
    const { detail } = props;
    const id = detail.id;
    apis.deleteKnowledge(id).then(res => {
      if (res.code === '0') {
        message.success('删除成功');
        handleCancel(true);
      }
    });
  };

  //点击“取消按钮”隐藏对话框
  const handleCancel = changed => {
    props.onCancel(changed);
  };

  return (
    <div className="group-modal">
      <Modal
        title="提示"
        visible={props.visible}
        width={'50%'}
        height={'60%'}
        className="group-manager"
        footer={[
          <Button
            key="cancel"
            onClick={() => handleCancel(false)}
            type="default"
            className="btn-cancel"
          >
            {i18n.t('cancel')}
          </Button>,
          <Button
            key="submit"
            type="danger"
            onClick={handleOk}
            className="btn-ok"
          >
            删除
          </Button>,
        ]}
      >
        <div className="report-modal-alert-content">
          <p>此操作将永久删除该条信息, 是否继续?</p>
        </div>
      </Modal>
    </div>
  );
};
Delete.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.object,
  detail: PropTypes.object,
};
export default withRouter(Form.create()(Delete));
